import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/category/variety", label: "综艺" },
  { to: "/category/documentary", label: "纪录片" },
  { to: "/special", label: "专题" },
  { to: "/about", label: "关于" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? "text-accent-500" : "text-background-100/85 hover:text-background-50"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-900/95 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-tv-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-background-50">
            棒棒<span className="text-accent-500">TV</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center md:ml-6">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <Link
            to="/search"
            className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100 transition-colors hover:bg-accent-500 hover:text-background-50"
            aria-label="搜索影视内容"
          >
            <i className="ri-search-line text-lg"></i>
          </Link>
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100 transition-colors hover:bg-primary-700 lg:hidden cursor-pointer"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="border-t border-primary-800 bg-primary-900 px-4 pb-4 lg:hidden animate-fade">
          <div className="flex flex-col py-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-800 text-accent-500"
                      : "text-background-100 hover:bg-primary-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}